module.exports = __webpack_public_path__ + "img/uparrow.f02f1846.svg";